<script>
const TYPE_LABELS = {
  CARD_LINKED: { label: 'Card-linked', cls: 'bg-indigo-100 text-indigo-800 border-indigo-200' },
  AFFILIATE: { label: 'Affiliate', cls: 'bg-sky-100 text-sky-800 border-sky-200' },
  IN_STORE: { label: 'In-store', cls: 'bg-amber-100 text-amber-800 border-amber-200' },
  ONLINE: { label: 'Online', cls: 'bg-violet-100 text-violet-800 border-violet-200' },
}

export default {
  name: 'LegacyOfferTypePill',
  props: {
    type: { type: String, default: '' },
  },
  computed: {
    info() {
      return TYPE_LABELS[this.type] || { label: this.type, cls: 'bg-gray-100 text-gray-800 border-gray-200' }
    },
  },
}
</script>

<template>
  <span
    :class="[
      'inline-flex items-center rounded-full border px-2 py-0.5 text-xs font-medium whitespace-nowrap',
      info.cls,
    ]"
  >
    {{ info.label }}
  </span>
</template>
